module.exports = __webpack_public_path__ + "img/example_xls.7bcf9e35.png";